import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["id", "targetRef", "onCloseRequested"];
import { useForkRef } from "@smartsheet/lodestar-utils";
import { genId } from "@smartsheet/lodestar-utils";
import { useCallback, useMemo, useRef } from "react";
/**
 * Hook that connects the Flyout and its target element
 * to support good a11y and make sure the refs are passed around properly!
 */
export function useFlyout(_ref) {
  var providedFlyoutId = _ref.id,
    providedTargetRef = _ref.targetRef,
    providedOnCloseRequested = _ref.onCloseRequested,
    flyoutProps = _objectWithoutProperties(_ref, _excluded);
  // Use the provided ref for the target element if it's there, otherwise make our own.
  var localRef = useRef(null);
  var targetRef = useForkRef(providedTargetRef || null, localRef);

  // Sync the ids between the target and Flyout.
  var generatedId = useMemo(function () {
    return genId("flyout-target");
  }, []);
  var flyoutId = providedFlyoutId || generatedId;

  // Add a default onCloseHandler that re-focuses the target element.
  var onCloseRequested = useCallback(function () {
    providedOnCloseRequested();
    if (localRef.current) {
      localRef.current.focus();
    }
  }, [providedOnCloseRequested]);

  // These things should be spread onto their corresponding React components.
  // They are all the things a component needs to be happy and Flyout-ey.
  return {
    targetProps: {
      "aria-owns": flyoutProps.isOpen ? flyoutId : undefined,
      ref: targetRef
    },
    flyoutProps: _objectSpread(_objectSpread({}, flyoutProps), {}, {
      id: flyoutId,
      targetElement: localRef,
      onCloseRequested: onCloseRequested
    })
  };
}
//# sourceMappingURL=useFlyout.js.map